export const parsePrice = (value) => {
  if (value === null || value === undefined) return 0;

  let str = String(value).trim();
  if (!str) return 0;

  // Sembol ve boşlukları temizle (₺, $, vb.)
  str = str.replace(/[^\d.,]/g, '');

  if (!str) return 0;

  const hasDot = str.includes('.');
  const hasComma = str.includes(',');

  // Hem nokta hem virgül varsa: son görüneni ondalık ayırıcı kabul et
  if (hasDot && hasComma) {
    const lastDot = str.lastIndexOf('.');
    const lastComma = str.lastIndexOf(',');

    if (lastComma > lastDot) {
      // 4.999,99 -> 4999.99
      str = str.replace(/\./g, '').replace(',', '.');
    } else {
      // 4,999.99 -> 4999.99
      str = str.replace(/,/g, '');
    }
  } else if (hasComma && !hasDot) {
    // Sadece virgül varsa, onu ondalık ayırıcı olarak düşün: 4,99 -> 4.99
    str = str.replace(',', '.');
  } else {
    // Sadece nokta varsa: 4.999 veya 4999.99 olabilir.
    // Burada ek işlem yapmıyoruz, parseFloat doğrudan okuyacak.
  }

  const num = parseFloat(str);
  if (Number.isNaN(num)) return 0;
  return num;
};

export const formatPriceWithoutCents = (value, options = {}) => {
  const {
    locale = 'tr-TR',
    minimumFractionDigits = 0,
    maximumFractionDigits = 0
  } = options;

  const num = parsePrice(value);
  const rounded = Math.round(num);
  return rounded.toLocaleString(locale, { minimumFractionDigits, maximumFractionDigits });
};

